import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import router from './router' // Import router
import setupGTM from './plugins/gtm' // Import GTM plugin

import '@/style.css'
import '@fortawesome/fontawesome-free/css/all.css'

// Import language files
import en from './locales/en.json'
import es from './locales/es.json'

// Function to detect browser language
function getBrowserLanguage() {
  // Get browser language (comes in format like 'en-US', 'es-ES')
  const browserLang = navigator.language || navigator.userLanguage;
  
  // Extract just the language code part
  const langCode = browserLang.split('-')[0];
  
  // Return the language if supported, otherwise default to English
  return ['en', 'es'].includes(langCode) ? langCode : 'en';
}

// Create i18n instance
const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('userLocale') || getBrowserLanguage(),
  fallbackLocale: 'en',
  messages: { en, es }
})

const app = createApp(App)
app.use(router) // Use router
app.use(i18n)

// Setup Google Tag Manager
setupGTM(app, router)

app.mount('#app')